export default __webpack_public_path__ + "locales/it/Common.json?hash=c031a76c2e113c3635a06b0cfd570d74";